/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */
package systems.frictionless.impulse.browser.composable.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import kotlinx.browser.document
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLElement
import systems.frictionless.impulse.browser.SharedIds

/**
 * Animated work indicator.
 */
@Composable
fun LoadingIndicator() {
    val loadingIndicatorId = SharedIds.LOADING_INDICATOR_ID
    Div {
        DisposableEffect("loading_indicator") {
            updateIndicatorVisibility(loadingIndicatorId, CssVisibilityValue.Visible)

            onDispose {
                updateIndicatorVisibility(loadingIndicatorId, CssVisibilityValue.Hidden)
            }
        }
    }
}

private fun updateIndicatorVisibility(
    elementId: String,
    newState: CssVisibilityValue
) {
    val loadingIndicator: HTMLElement? = document.getElementById(elementId) as HTMLElement?
    if (loadingIndicator != null) {
        loadingIndicator.style.visibility = newState.cssValue
    }
}

internal enum class CssVisibilityValue(internal val cssValue: String) {
    Hidden("hidden"),
    Visible("visible")
}
